import Search from 'antd/es/input/Search';
import type { DataNode } from 'antd/es/tree';
import { useStore } from '../../../store/reducers';
import { Filters } from './FilterTreeFunctions';
import { customDataNode, draggableDataNode } from './nodes';
import type { DataNodeProps } from './prepareFilterSubTreeComponentMapping';

export const UsersFilterNode = (props: DataNodeProps): DataNode => {
  const { key, title } = props;
  const filterCounts = useStore((s) => s.trackers.filterCounts);
  const counts = filterCounts.get(Filters.Users);
  const users = useStore((s) => s.trackers.users);

  const { setUserSearchValue } = useStore((s) => s.trackers.actions);

  const roles = ['owner', 'borrower', 'editor'];

  const usersArray = Array.from(users.entries()).map(([userId, user]) => ({
    userId,
    name: user?.name || '',
    email: user?.email || '',
  }));

  const childrenNodes = usersArray.map(({ userId, name, email }) => {
    const roleNodes = roles.map((role) =>
      draggableDataNode(role, `${key}/${userId}/${role}`, counts?.get(`${userId}/${role}`)),
    );
    return customDataNode(
      name || email || userId,
      `${key}/${userId}`,
      counts?.get(userId),
      roleNodes,
    );
  });

  return {
    key,
    title,
    children: [
      {
        title: (
          <Search
            allowClear
            placeholder="Search Users"
            size="small"
            onChange={(e) => setUserSearchValue(e.target.value)}
          />
        ),
        key: `${key}/search`,
        disabled: true,
      },
      ...childrenNodes,
    ],
    disableCheckbox: true,
  };
};
